import { Injectable } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { FormValidationService } from "./form-validation.service";
import { HttpService } from "./http.service";

import { environment } from "../../../environments/environment";

@Injectable()
export class FormLoaderService {
  constructor(
    private http: HttpService,
    private fb: FormBuilder,
    private _formvalidationService: FormValidationService,
  ) {}

  getForm(
    formCode: string,
    formVersionCode: string,
    formSubCode: string,
    campusCode: string,
  ) {
    if (formSubCode) {
      return this.http.get(
        `${environment.SURVEY_STORE_URL}/formSubmission/submissionCode/${formSubCode}`,
      );
    }

    if (!formVersionCode) {
      return this.http.get(
        `${environment.SURVEY_STORE_URL}/form/formCode/${formCode}/campusCode/${campusCode}`,
      );
    }

    return this.http.get(
      `${environment.SURVEY_STORE_URL}/form/formCode/${formCode}/formVersion/${formVersionCode}/campusCode/${campusCode}`,
    );
  }

  postForm(formPostData: any, userId: string, campusCode: string) {
    console.log("postiing form data");
    console.log(formPostData);
    const jsonPostBody = JSON.stringify(formPostData);
    console.log(jsonPostBody);
    return this.http.post(
      `${environment.SURVEY_STORE_URL}/formSubmission/userId/${userId}/campusCode/${campusCode}`,
      jsonPostBody,
    );
  }

  putForm(
    formPostData: any,
    env: any,
    formSubmissionCode: any,
    userId: string,
  ) {
    const jsonPostBody = JSON.stringify(formPostData);
    return this.http.put(
      `${environment.SURVEY_STORE_URL}/formSubmission/${formSubmissionCode}/userId/${userId}`,
      jsonPostBody,
    );
  }

  buildForm(data) {
    let form = this.fb.group({});
    form = this.fb.group({
      formCode: data.formCode,
      formVersionCode: data.formVersionCode,
      complete: true,
      formSections: this.fb.array(this.buildFormSections(data.formSections)),
    });
    return form;
  }

  buildFormSections(sections) {
    let sectionsArray = [];
    sections.forEach((section) => {
      let group = {
        responses: this.fb.array(this.buildSectionQuestions(section.questions)),
      };
      sectionsArray.push(this.fb.group(group));
    });
    return sectionsArray;
  }

  buildSectionQuestions(questions) {
    let questionsArray = [];
    questions.forEach((question) => {
      let group: any = {
        questionSequenceCode: question.questionSequenceCode,
        iterations: this.fb.array(this.buildIterations(question)),
      };
      questionsArray.push(this.fb.group(group));
    });
    return questionsArray;
  }

  buildIterations(question) {
    let iterationsArray = [];
    let currentIterations: any = 0;
    if (question.type !== "search") {
      let group = {
        iteration: 1,
        response: this._formvalidationService.buildFormControl(question),
        responseMetadata: this.buildResponseMetadata(question),
      };
      iterationsArray.push(this.fb.group(group));
    } else {
      const formControl =
        this._formvalidationService.buildFormControl(question);
      question.iterations.forEach((iteration, i) => {
        let group = {
          iteration: i + 1,
          response: this.fb.control(iteration.responseText),
          responseMetadata: this.buildSearchResponseMetadata(iteration),
        };
        iterationsArray.push(this.fb.group(group));
      });
    }
    return iterationsArray;
  }

  buildResponseMetadata(question) {
    let responseMetadata = {};
    if (
      question.type === "radio" ||
      question.type === "dropdown" ||
      question.type === "checkbox"
    ) {
      responseMetadata["allowedResponses"] = question.allowedOptions
        ? question.allowedOptions
        : question.iterations[0].responseMetadata &&
            question.iterations[0].responseMetadata.allowedResponses
          ? question.iterations[0].responseMetadata.allowedResponses
          : null;
      responseMetadata["chosenResponses"] =
        question.iterations[0].responseMetadata &&
        question.iterations[0].responseMetadata.chosenResponses
          ? question.iterations[0].responseMetadata.chosenResponses
          : [];
    } else {
      responseMetadata = null;
    }
    return responseMetadata;
  }

  buildSearchResponseMetadata(iteration) {
    return {
      allowedResponses: null,
      chosenResponses:
        iteration.responseMetadata && iteration.responseMetadata.chosenResponses
          ? iteration.responseMetadata.chosenResponses
          : [],
    };
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/formloader.service.ts